import { SYNC_MEDIA_REASONS } from '../../../../helpers/shopify/resolveSyncMediaSelectionState';
import localization from '../../../../shared/strings';

const VALIDATION_STRINGS = localization.DIALOGS.PRODUCT_DIALOGS.CONNECT_CHANNEL.MEDIA_VALIDATION;

/**
 * Tile tooltip: filename, optionally with Shopify validation status.
 *
 * @param {string} filename
 * @param {{ reason?: string|null }|null} selectionState
 * @returns {string}
 */
export default function getSyncMediaTileTooltip(filename, selectionState) {
  const status = getSyncMediaStatusLabel(selectionState?.reason);
  if (!status) {
    return filename;
  }
  return `${filename} — ${status}`;
}

/**
 * @param {string|null|undefined} reason
 * @returns {string|null}
 */
export function getSyncMediaStatusLabel(reason) {
  switch (reason) {
  case SYNC_MEDIA_REASONS.NEEDS_PREPARE:
    return VALIDATION_STRINGS.STATUS_NEEDS_PREPARE;
  case SYNC_MEDIA_REASONS.THUMBNAIL_PROCESSING:
    return VALIDATION_STRINGS.STATUS_THUMBNAIL_PROCESSING;
  case SYNC_MEDIA_REASONS.THUMBNAIL_FAILED:
    return VALIDATION_STRINGS.STATUS_THUMBNAIL_FAILED;
  case SYNC_MEDIA_REASONS.THUMBNAIL_MISSING:
    return VALIDATION_STRINGS.STATUS_THUMBNAIL_MISSING;
  case SYNC_MEDIA_REASONS.UNSUPPORTED_MEDIA_TYPE:
    return VALIDATION_STRINGS.STATUS_UNSUPPORTED_MEDIA_TYPE;
  default:
    return null;
  }
}
